// src/features/plan/recommendationsClient.js
//
// PLAN-RECOMMENDATIONS-TAB: Thin fetch wrappers for /api/plan/recommendations.

const BASE = "/api/plan/recommendations";

async function fetchJson(url, options = {}) {
  const res = await fetch(url, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw Object.assign(new Error(body.error ?? `HTTP ${res.status}`), {
      status: res.status,
      body,
    });
  }
  return res.json();
}

/**
 * Run the recommendation engine and return the current set.
 * Returns { candidates, published }.
 * Viewer role will see only published (candidates = []).
 */
export function getRecommendations() {
  return fetchJson(BASE);
}

/**
 * Curate a single recommendation.
 *
 * @param {string} id           — plan_recommendations.id (UUID)
 * @param {string} action       — "accept" | "dismiss" | "snooze" | "edit"
 * @param {object} [opts]
 * @param {string} [opts.dismissReason]  — required when action="dismiss"
 * @param {string} [opts.snoozeUntil]    — ISO date, required when action="snooze"
 * @param {object} [opts.editFields]     — { title?, priority?, why? }
 */
export function curateRecommendation(id, action, opts = {}) {
  return fetchJson(`${BASE}/${id}/curate`, {
    method: "PATCH",
    body:   JSON.stringify({ action, ...opts }),
  });
}

/**
 * Un-publish (revert accepted → candidate) a recommendation.
 * Convenience wrapper over curateRecommendation with action="unpublish".
 *
 * @param {string} id
 */
export function unpublishRecommendation(id) {
  return fetchJson(`${BASE}/${id}/curate`, {
    method: "PATCH",
    body:   JSON.stringify({ action: "unpublish" }),
  });
}
